// Import the functions you need from the Firebase SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Firestore
import { getStorage } from "firebase/storage"; // Storage
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  FacebookAuthProvider, 
  RecaptchaVerifier, 
  signInWithPhoneNumber 
} from "firebase/auth"; // Authentication
import { getMessaging, getToken, onMessage } from "firebase/messaging";


// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Export Firebase services
export const db = getFirestore(app); // Firestore
export const storage = getStorage(app); // Firebase Storage
export const auth = getAuth(app); // Firebase Authentication
export const provider = new GoogleAuthProvider(); // Google Auth Provider
export const facebookProvider = new FacebookAuthProvider();
export { messaging, getToken, onMessage };

// PayPal
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

// Export RecaptchaVerifier (Fix)
export { RecaptchaVerifier };

// Google Sign-In function
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    // console.log("Google Sign-In Successful:", result.user);
    return result.user;
  } catch (error) {
    console.error("Google Sign-In Error:", error);
    throw error;
  }
};

// Facebook Sign-In function
export const signInWithFacebook = async () => {
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    console.log("Facebook Sign-In Successful:", result.user);
    return result.user;
  } catch (error) {
    console.error("Facebook Sign-In Error:", error);
    throw error;
  }
};

// OTP Authentication (Phone Sign-In)
export const sendOtp = async (phoneNumber) => {
  try {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "invisible",
        callback: () => console.log("Recaptcha verified"),
      });
    }

    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, window.recaptchaVerifier);
    return confirmationResult;
  } catch (error) {
    console.error("OTP Sending Error:", error);
    throw error;
  }
};

// Verify OTP Code
export const verifyOtp = async (confirmationResult, otp) => {
  try {
    const result = await confirmationResult.confirm(otp);
    console.log("OTP Verified:", result.user);
    return result.user;
  } catch (error) {
    console.error("OTP Verification Error:", error);
    throw error;
  }
};

// Debugging output
console.log("🔥 Firebase Connected MacVision_IT_Solution:", app.name); // Should log "DEFAULT"
